var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegratedAi = function SvgIntegratedAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_95_2869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_95_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5063 4.33331H8.125V2.70831H17.1313L15.5063 4.33331ZM11.5064 8.33325H4.875V6.70825H13.1314L11.5064 8.33325ZM7.50642 12.3332H1.625V10.7082H9.13142L7.50642 12.3332ZM16.1084 15.0001L13.2917 12.1834L7.93758 17.5375C7.87511 17.6 7.84388 17.6764 7.84388 17.7666C7.84388 17.8569 7.87511 17.9333 7.93758 17.9958L10.2957 20.3542C10.3584 20.4167 10.4348 20.4479 10.5251 20.4479C10.6154 20.4479 10.6918 20.4167 10.7542 20.3542L16.1084 15.0001ZM14.45 11.0251L17.2667 13.8417L22.6354 8.473C22.6979 8.41053 22.7291 8.33063 22.7291 8.23331C22.7291 8.13599 22.6979 8.0561 22.6354 7.99363L20.2979 5.65633C20.2354 5.59386 20.1556 5.56263 20.0585 5.56263C19.9611 5.56263 19.8812 5.59386 19.8188 5.65633L14.45 11.0251ZM12.7376 10.4541L17.8374 15.5542L11.8958 21.4958C11.5042 21.8874 11.0473 22.0832 10.5251 22.0832C10.0028 22.0832 9.54579 21.8874 9.15417 21.4958L9.01658 21.3582L8.04158 22.3332H3.83337L6.91248 19.2541L6.79602 19.1373C6.40422 18.7457 6.20831 18.2888 6.20831 17.7666C6.20831 17.2445 6.40422 16.7876 6.79602 16.396L12.7376 10.4541ZM12.7376 10.4541L18.6875 4.50421C19.0791 4.11258 19.5361 3.91677 20.0585 3.91677C20.5806 3.91677 21.0375 4.11258 21.4291 4.50421L23.7876 6.86263C24.1792 7.25425 24.375 7.71115 24.375 8.23331C24.375 8.75548 24.1792 9.21237 23.7876 9.604L17.8374 15.5542L12.7376 10.4541Z",
    fill: "#717E9B"
  }))));
};
export default SvgIntegratedAi;